export function PM_Handle_PicQueue(picMgr) {
  if (picMgr == null) return;

  if (picMgr.fPausePicQueue) return;

  var lc = picMgr.fPicActiveLoadCount;
  var pq = picMgr.fPicQueue;

  var concurrent = 3;

  while (lc < concurrent) {
    var n = pq.length;
    if (n > 0) {
      var nextImage;
      nextImage = pq.pop();
      nextImage.src = nextImage["picURL"];
      picMgr.fPicActiveLoadCount++;
    } else return;

    lc = picMgr.fPicActiveLoadCount;
  }
}
